var render, staticRenderFns
import script from "./CustomMaskLabel.vue?vue&type=script&lang=js"
export * from "./CustomMaskLabel.vue?vue&type=script&lang=js"
import style0 from "./CustomMaskLabel.vue?vue&type=style&index=0&id=5ec5bf41&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec5bf41",
  null
  
)

export default component.exports